import { Heading } from '@/frontend/legacy/components/Page/Heading'

export const Headline = ({
  headline,
  subline,
  roofline,
  tag = 'h2',
  tagStyle = 'default',
  inlineComponent = true,
  alignment = 'left',
  show = true,
}) => {
  if (!headline || !show) {
    return null
  }

  // headlines can contain '%' to mark the beginning of a span and the end of a span
  // e.g. "This is a headline with a <span>span</span> in it"
  // these spans should contain a class name to style them
  const headlineParts = headline.split('%')
  const spanClass = 'background-tag'
  const headlinePartsClass =
    headlineParts.length > 1 ? 'headline-multiple-tags' : 'headline-part-default'

  const classNames = [
    'headline-element-container',
    `alignment-${alignment}`,
    inlineComponent ? 'inline-component' : 'standalone',
  ].join(' ')

  const HeadlinePartElement = ({ part }) => <>{part}</>

  const HeadlineParts = () => {
    return headlineParts.map((part, index) => {
      if (index % 2 === 0) {
        return <HeadlinePartElement key={index} part={part} />
      }
      return (
        <span key={index} className={spanClass}>
          {part}
        </span>
      )
    })
  }

  return (
    <div className={classNames}>
      <p className="roofline">{roofline}</p>
      <Heading as={tag} className={`heading-style-${tagStyle} ${headlinePartsClass}`}>
        <HeadlineParts />
      </Heading>
      <p className="subline">{subline}</p>
    </div>
  )
}
